import roles from '@/constants/roles';
import clientRoles from '@/constants/clientRoles';

export default Object.freeze([
    {
        name: 'clients',
        roles: [
            roles.ADMINISTRATOR.value,
            roles.MANAGER.value,
            roles.LABORATORY_MANAGER.value,
            roles.LABORATORY_MICROBIOLOGIST.value,
            roles.SALES_REPRESENTATIVE.value,
            roles.SALES_MANAGER.value,
            roles.LABORATORY_TECHNICIAN.value,
            roles.LABORATORY_CHEMIST.value,
            roles.SERVICE_TECHNICIAN.value,
            clientRoles.OPERATOR,
        ],
    },
    {
        name: 'sites',
        roles: [
            roles.ADMINISTRATOR.value,
            roles.MANAGER.value,
            roles.LABORATORY_MANAGER.value,
            roles.LABORATORY_MICROBIOLOGIST.value,
            roles.SALES_REPRESENTATIVE.value,
            roles.SALES_MANAGER.value,
            roles.LABORATORY_TECHNICIAN.value,
            roles.LABORATORY_CHEMIST.value,
            roles.SERVICE_TECHNICIAN.value,
            clientRoles.OPERATOR,
        ],
    },
    {
        name: 'services',
        roles: [
            roles.ADMINISTRATOR.value,
            roles.MANAGER.value,
            roles.LABORATORY_MANAGER.value,
            roles.LABORATORY_MICROBIOLOGIST.value,
            roles.SALES_REPRESENTATIVE.value,
            roles.SALES_MANAGER.value,
            roles.LABORATORY_TECHNICIAN.value,
            roles.LABORATORY_CHEMIST.value,
            roles.SERVICE_TECHNICIAN.value,
        ],
    },
    {
        name: 'administration',
        roles: [
            roles.ADMINISTRATOR.value,
            roles.FINANCIAL_ADMINISTRATOR.value,
            roles.MANAGER.value,
            roles.LABORATORY_MANAGER.value,
            roles.LABORATORY_MICROBIOLOGIST.value,
        ],
    },
    {
        name: 'laboratory',
        roles: [
            roles.ADMINISTRATOR.value,
            roles.MANAGER.value,
            roles.LABORATORY_MANAGER.value,
            roles.LABORATORY_MICROBIOLOGIST.value,
            roles.LABORATORY_TECHNICIAN.value,
            roles.LABORATORY_CHEMIST.value,
            roles.SALES_REPRESENTATIVE.value,
            roles.SALES_MANAGER.value,
            roles.SERVICE_TECHNICIAN.value,
        ],
    },
]);
